export const EnvironmentConfig = {
    Environment: process.env.REACT_APP_ENVIRONMENT ?? "",
    BaseUrl: process.env.REACT_APP_API_URL ?? "",
    BaseDomain: process.env.REACT_APP_API_DOMAIN ?? "",
    PasswordAuthClientId: process.env.REACT_APP_PASSWORD_AUTH_CLIENT_ID ?? "",
    PasswordAuthClientSecret: process.env.REACT_APP_PASSWORD_AUTH_CLIENT_SECRET ?? "",
    IndexDBVersion: process.env.REACT_APP_INDEX_DB_VERSION ? Number(process.env.REACT_APP_INDEX_DB_VERSION) : 1,
    PreviewImageWidth: process.env.REACT_APP_PREVIEW_IMAGE_WIDTH ? Number(process.env.REACT_APP_PREVIEW_IMAGE_WIDTH) : 720,
    ReCaptchaEnable: process.env.REACT_APP_RECAPTCHA_ENABLE == "true",
    ReCaptchaClientId: process.env.REACT_APP_RECAPTCHA_CLIENT_ID ?? "",
    ReCaptchaUrl: process.env.REACT_APP_RECAPTCHA_SCRIPT_URL ?? "",
    SharedLinkTitle: process.env.SHARED_LINK_TITLE ?? "",
    MapsApiKey: process.env.GOOGLE_API_KEY ?? "",
    SeasonFilter: process.env.REACT_APP_SEASON_FILTER ?? ""
}
